import { inject, injectable } from 'tsyringe';
import type { IAgentSurveyClient } from 'interfaceAdapter/gatewaySchemas/IAgentSurveyClient';
import type { IAgentUserTokenRepository } from 'application/repositorySchemas/IAgentUserTokenRepository';
import { IAgentSurveyQuery } from 'application/querySchemas/IAgentSurveyQuery';
import type { ISurveyFactory } from 'domain/valueObjects/factories/Survey';
import { ISurvey } from 'domain/entities/Survey/Survey';

@injectable()
export class AgentSurveyQuery implements IAgentSurveyQuery {
    constructor(
        @inject('IAgentUserTokenRepository')
        public readonly agentUserToken: IAgentUserTokenRepository,
        @inject('IAgentSurveyClient')
        public readonly surveyClient: IAgentSurveyClient,
        @inject('SurveyFactory')
        public readonly factory: ISurveyFactory,
    ) {}

    public async fetch(matchId: number): Promise<ISurvey> {
        const { data, message } = await this.surveyClient.get({
            token: this.agentUserToken.get() || '',
            matchId,
        });

        if (message) {
            throw new Error(message);
        }

        if (!data) throw new Error('アンケート情報の取得に失敗しました');

        return this.factory.buildSurvey(data);
    }
}
